<template>
  <footer class="templates-app-footer text-light">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <main-menu @logout="$emit('logout')" class="mb-4" />
        </div>
        <div class="col-lg-3 col-md-6">
          <a class="btn" href="javascript:openSupport()">Ajuda</a>
          <a
            href="https://api.whatsapp.com/send?phone=5544991677448"
            target="_blank"
            class="btn"
            >Contato</a
          >
          <router-link class="btn" :to="{ name: 'terms' }"
            >Termo de uso</router-link
          >
          <router-link class="btn" :to="{ name: 'privacy' }"
            >Privacidade</router-link
          >
        </div>
      </div>
      <div class="d-flex pt-4 align-items-end">
        <img class="logo" src="../../assets/images/logo-small.png" />
        <div class="flex-fill"></div>
        <div class="d-flex flex-column align-items-end">
          <div
            class="d-flex justify-content-center align-items-center social-links"
          >
            <a
              class="text-light ml-3"
              href="https://www.instagram.com/italomarsili/"
              target="_blank"
            >
              <i class="icon-instagram"></i>
            </a>
            <a
              class="text-light ml-3"
              href="https://www.facebook.com/marsili.italo"
              target="_blank"
            >
              <i class="icon-facebook-square"></i>
            </a>
            <a
              class="text-light ml-3"
              href="https://www.youtube.com/user/italomarsili"
              target="_blank"
            >
              <i class="icon-youtube-play"></i>
            </a>
            <a
              class="text-light ml-3"
              href="https://api.whatsapp.com/send?phone=5521990096367"
              target="_blank"
            >
              <i class="icon-whatsapp"></i>
            </a>
          </div>
          <small>© {{ currentYear }} Real Life</small>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import MainMenu from "./MainMenu";

export default {
  components: { MainMenu },
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  }
};
</script>

<style lang="scss" scoped>
.templates-app-footer {
  background: #131212;
  padding: 32px 0;

  ::v-deep .hide-footer {
    display: none;
  }

  ::v-deep a {
    color: white !important;
    padding: 8px 0 !important;
    min-height: 0;
    opacity: 0.8;
    display: block;
    text-align: left;

    &:hover {
      opacity: 1;
    }
  }

  .logo {
    max-width: 100px;
  }

  .social-links {
    a {
      text-decoration: none;
      opacity: 0.5;
      transition: opacity 0.2s;

      &:hover {
        opacity: 1;
      }

      i {
        font-size: 26px;
      }
    }
  }
}
</style>
